import GuaranteesCover from './GuaranteesCover';

export default GuaranteesCover;
